/*
 * Marks a shopper who has added something to the cart, so an A/B test can
 * enrol only those shoppers (docs/intelligems-atc-enrol/README.md).
 *
 * On the first real add, sets the session cookie `jnco_added_to_cart=1`. The
 * Intelligems test's audience is a JavaScript condition that reads it
 * (`document.cookie.includes('jnco_added_to_cart=1')`), with "Do not assign it"
 * for visitors who don't match, so the shopper is enrolled on their next page
 * load.
 *
 * Adds reach the theme as the pubsub `cart-update` event. Its `cart-items`
 * source is a quantity change or removal in the drawer or on the cart page,
 * not an add. The automatic shipping protection add publishes nothing.
 * Loaded deferred right after pubsub.js, so `subscribe` already exists.
 */
(() => {
  if (window.__cartAddEnrolInit || typeof subscribe !== 'function') return;
  window.__cartAddEnrolInit = true;

  const COOKIE = 'jnco_added_to_cart';

  subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
    if (!event || event.source === 'cart-items') return;
    if (event.cartData && event.cartData.status) return;
    if (document.cookie.split('; ').includes(`${COOKIE}=1`)) return;
    document.cookie = `${COOKIE}=1; path=/; SameSite=Lax`;
  });
})();
